
import { Component } from '@angular/core';

@Component({
    selector: 'app-custom',
    template: `<p>success</p>`,
    standalone: true,
    imports: []
})
export class CustomComponent {
}
